import React, { useState, useEffect, useRef } from 'react';
import LoadingScreen from './components/LoadingScreen';
import './App2.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState('home');

  const sections = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      const sectionOffsets = sections.current.map(section => ({
        id: section.id,
        offsetTop: section.offsetTop,
        offsetHeight: section.offsetHeight
      }));

      const scrollPosition = window.scrollY + window.innerHeight / 2;

      for (const section of sectionOffsets) {
        if (
          scrollPosition >= section.offsetTop &&
          scrollPosition < section.offsetTop + section.offsetHeight
        ) {
          setActiveSection(section.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {loading ? (
        <LoadingScreen onFinishLoading={() => setLoading(false)} />
      ) : (
        <div className="App">
          <header className="header" id="home" ref={el => sections.current[0] = el}>
            <div className="navbar">
              <div className="navbar-left">
                <a href="#home">
                  <i className="fa-regular fa-user"></i>
                  <span className="ahmad-name">
                    <span> </span>
                    <span className="highlight">Ahmad</span> Jabbar
                  </span>
                </a>
              </div>
              <div className="navbar-right">
                <a href="#home" className={activeSection === 'home' ? 'active' : ''}>Home</a>
                <a href="#about" className={activeSection === 'about' ? 'active' : ''}>About</a>
                <a href="#services" className={activeSection === 'services' ? 'active' : ''}>Services</a>
                <a href="#services" className={activeSection === 'skills' ? 'active' : ''}>Skills</a>
                <a href="#projects" className={activeSection === 'projects' ? 'active' : ''}>Projects</a>
                <a href="#contact" className={activeSection === 'contact' ? 'active' : ''}>Contact</a>
              </div>
            </div>
            <div className="intro">
              <h1>
                Hi, I am <span className="highlight">Ahmad Jabbar</span>
              </h1>
              <p>
                I am a Full Stack Developer and App Developer who builds easy-to-use and strong applications. I also have an interest in data science, using data to find insights and create new solutions.
              </p>
              <div className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ahmad-jabbar-554b292ab/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
              </div>
            </div>
          </header>
          <section id="about" className="about-section" ref={el => sections.current[1] = el}>
            <div className="container">
              <div className="about-content">
                <img
                  src="/profile.jpg"
                  alt="Ahmad Jabbar"
                  className="profile-img"
                />{" "}
                <div className="about-text">
                  <h2 className="aboutme-heading">About Me</h2>
                  <h1>Hi There! I'm Ahmad Jabbar</h1>
                  <h3 className="highlight">Full Stack Developer</h3>
                  <p>
                    I am a Full Stack Developer and App Developer who creates user-friendly and robust applications. I also have a strong interest in data science,
                    using data to uncover insights and develop innovative solutions. I commit to my work with dedication, hard work, and passion. I enjoy learning and
                    continuously improving my skills.
                  </p>
                  <ul>
                    <li>
                      <strong>Phone:</strong> +92 308 5488 565
                    </li>
                    <li>
                      <strong>Email:</strong> 25100002@lums.edu.pk
                    </li>
                    <li>
                      <strong>Location:</strong> Lahore
                    </li>
                    <li>
                      <strong>Languages:</strong> English, Urdu
                    </li>
                    <li>
                      <strong>Freelance:</strong> Available
                    </li>
                  </ul>
                  <button className="download-cv" onClick={() => window.open('https://drive.google.com/file/d/15vNk-YVCXhtzkdtJurusdCiszzpr8V3D/view')}>
                    Download CV
                  </button>

                </div>
              </div>
            </div>
          </section>
          <section id="services" className="services-section" ref={el => sections.current[2] = el}>
            <div className="container">
              <h2 className="section-heading">Services</h2>
              <div className="scroll-container">
                <div className="services-card">
                  <h2 className='services-heading'>App Development</h2>
                  <img src="/logo2.png" alt="Logo" className="services-logo" />
                  <p>
                    I design and develop mobile applications for both iOS and Android platforms. This includes creating intuitive user interfaces, integrating robust backend services, and ensuring seamless performance across devices. I use technologies like Flutter to build high-quality apps. My aim is to deliver engaging, user-friendly, and high-performing mobile experiences.
                  </p>
                </div>
                <div className="services-card">
                  <h2 className='services-heading'>Full Stack Development</h2>
                  <img src="/logo4.png" alt="Logo" className="services-logo" />
                  <p>
                    I create complete web applications from start to finish. This includes designing the user interface, developing the backend systems, and ensuring smooth interaction between them. I work with various technologies to deliver responsive and dynamic websites. My goal is to build functional, user-friendly, and visually appealing web solutions.
                  </p>
                </div>
                <div className="services-card">
                  <h2 className='services-heading'>Data Science</h2>
                  <img src="/ds1.png" alt="Logo" className="services-logo" />
                  <p>
                    I help turn data into useful insights for better decisions. I analyze and visualize data using tools like Python, and SQL. By studying data, I can find important patterns and trends. I use machine learning to make predictions and solve complex problems. Whether it's for improving business processes or understanding customer behavior, I can help make sense of the data.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section id="skills" className="skills-section" ref={el => sections.current[3] = el}>
            <div className="container">
              <h6 className="section-heading-skills">Skills</h6>
              <div className="skills-grid">
                <div className="skill-card">
                  <div className="skill-title">Flutter/Dart</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: '85%' }}></div>
                  </div>
                </div>
                <div className="skill-card">
                  <div className="skill-title">C/C++</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: '95%' }}></div>
                  </div>
                </div>
                <div className="skill-card">
                  <div className="skill-title">HTML/CSS</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: '85%' }}></div>
                  </div>
                </div>
                <div className="skill-card">
                  <div className="skill-title">Python</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: '90%' }}></div>
                  </div>
                </div>
                <div className="skill-card">
                  <div className="skill-title">TypeScript</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: '85%' }}></div>
                  </div>
                </div>
                <div className="skill-card">
                  <div className="skill-title">SQL</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: '80%' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="projects" className="projects-section" ref={el => sections.current[4] = el}>
            <div className="container">
              <h2 className="section-heading">Projects</h2>
              <div className="scroll-container">
                <div className="project-card">
                  <h2 className='projects-heading'>IntelliNotes</h2>
                  <img src="/intelliNotes3.png" alt="Logo" className="projects-logo" />
                  <p>
                    Developed IntelliNotes, an AI-powered note-taking app for Android, utilizing Flutter, Dart, GPT-3.5 API, and Firebase as a database. This innovative app offers enhanced note management capabilities including adding, deleting, locking, and pinning notes, along with a recovery option. It incorporates advanced GPT functionalities such as paraphrasing, summarizing, and automatic title generation. IntelliNotes also supports extensive organizational features, allowing users to categorize notes and toggle between light and dark themes for personalized user experience.
                  </p>
                </div>
                <div className="project-card">
                  <h2 className='projects-heading'>Twitter Trends Analysis</h2>
                  <img src="/covid1.png" alt="Logo" className="projects-logo" />
                  <p>
                    Leveraged a dataset from Kaggle containing tweets from July and August 2020 to analyze and predict social media trends on Twitter regarding Covid. Conducted a comprehensive hashtag analysis to identify the most commonly used hashtags about Covid-19 across different geographical regions. Utilized advanced machine learning models, including Neural Networks and Naive Bayes, to perform sentiment analysis, classifying tweets into positive, neutral, or negative categories. Additionally, analyzed tweet volumes to determine the top countries discussing COVID-19, and tracked trends in posting activity related to the pandemic.
                  </p>
                </div>
                <div className="project-card">
                  <h2 className='projects-heading'>Auction Web Application</h2>
                  <img src="/auction1.png" alt="Logo" className="projects-logo" />
                  <p>
                    Developed a dynamic Auction Web Application focusing on backend functionality with JavaScript, leveraging MongoDB for database management and Node.js for the server environment. The frontend was enhanced using TypeScript and Vite, creating a robust platform that allows users to list items for auction and engage in bidding. Special emphasis was placed on real-time interactivity; integrated socket programming ensures live updates for bidding activities and auction outcomes, enhancing user engagement and providing a seamless bidding experience without the need for browser refreshes. The application's architecture primarily concentrated on backend logic and performance, ensuring a responsive and efficient auction platform.
                  </p>
                </div>
                <div className="project-card">
                  <h2 className='services-heading'>Online Shopping Store Management System</h2>
                  <img src="/daraz1.png" alt="Logo" className="projects-logo" />
                  <p>
                    Developed a Management System of an online shopping store using the MERN stack (MongoDB, Express.js, React, and Node.js). It incorporated essential functionalities such as user authentication, user management, and data manipulation. The users were able to register as an admin, customer, or a seller. All three users had different use cases like adding products to the store, managing the inventory, placing an order, etc.
                  </p>
                </div>
                <div className="project-card">
                  <h2 className='services-heading'>Finding the blue sky </h2>
                  <img src="/aq3.png" alt="Logo" className="air-quality-logo" />
                  <p>
                    Conducted data analysis and visualization on the air quality data of Lahore using MATLAB. The analysis involved utilizing publicly available data obtained from air monitoring stations deployed at the U.S. Consulate in Lahore, monitoring stations deployed by the Punjab Environment Protection Department (EPD), and the crowd-sourced sensor network available from PurpleAir; Devised a calibration method to ensure accurate measurements for sensor locations that utilized inexpensive sensors. The objective was to gain insights into Lahore's air quality and establish a reliable and calibrated data set.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section id="contact" className="contact-section" ref={el => sections.current[5] = el}>
            <div className="container">
              <h2 className="section-heading">Contact</h2>
              <div className="contact-items">
                <div className="contact-item">
                  <a href="https://www.google.com/maps?q=Lahore,+Pakistan" target="_blank" rel="noopener noreferrer" className="contact-icon-link">
                    <div className="contact-icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                  </a>
                  <div className="contact-info">
                    <h3 className="contact-title">
                      <a href="https://www.google.com/maps?q=Lahore,+Pakistan" target="_blank" rel="noopener noreferrer" className="no-underline">Address</a>
                    </h3>
                    <p>
                      <a href="https://www.google.com/maps?q=Lahore,+Pakistan" target="_blank" rel="noopener noreferrer" className="underline-on-hover">Lahore, Pakistan</a>
                    </p>
                  </div>
                </div>
                <div className="contact-item">
                  <a href="mailto:25100002@lums.edu.pk,ahmadjabbar2002@gmail.com" className="contact-icon-link">
                    <div className="contact-icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                  </a>
                  <div className="contact-info">
                    <h3 className="contact-title">
                      <a href="mailto:25100002@lums.edu.pk,ahmadjabbar2002@gmail.com" className="no-underline">Email</a>
                    </h3>
                    <p>
                      <a href="mailto:25100002@lums.edu.pk,ahmadjabbar2002@gmail.com" className="underline-on-hover">
                        25100002@lums.edu.pk<br />ahmadjabbar2002@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="contact-item">
                  <a href="tel:+923085488565" className="contact-icon-link">
                    <div className="contact-icon-phone">
                      <i className="fas fa-phone-alt"></i>
                    </div>
                  </a>
                  <div className="contact-info-phone">
                    <h3 className="contact-title">
                      <a href="tel:+923085488565" className="no-underline">Phone</a>
                    </h3>
                    <a href="tel:+923085488565" className="phone-number underline-on-hover">+92 308 5488 565</a>
                  </div>
                </div>
              </div>
              <div className="footer">
                <p>Ahmad Jabbar 2024 | All Rights Reserved</p>
              </div>
            </div>
          </section>



        </div>
      )}
    </>
  );
}

export default App;
